import React from 'react'
import { rem } from 'polished'
import styled from 'styled-components'

import BodyTextBlock from 'components/Luxkit/TextBlocks/BodyTextBlock'
import { mediaQueryUp } from 'components/utils/breakpoint'
import LineUsersAltIcon from 'components/Luxkit/Icons/line/LineUsersAltIcon'
import LineUserMdIcon from 'components/Luxkit/Icons/line/LineUserMdIcon'
import LineWeightIcon from 'components/Luxkit/Icons/line/LineWeightIcon'
import LineBooksIcon from 'components/Luxkit/Icons/line/LineBooksIcon'
import LineShieldCheckIcon from 'components/Luxkit/Icons/line/LineShieldCheckIcon'
import LineLayersIcon from 'components/Luxkit/Icons/line/LineLayersIcon'
import LineBedDoubleIcon from 'components/Luxkit/Icons/line/LineBedDoubleIcon'
import LineBoltIcon from 'components/Luxkit/Icons/line/LineBoltIcon'
import LineDashboardIcon from 'components/Luxkit/Icons/line/LineDashboardIcon'
import LineRulerIcon from 'components/Luxkit/Icons/line/LineRulerIcon'
import LineShipIcon from 'components/Luxkit/Icons/line/LineShipIcon'

const FactsGrid = styled.div`
  display: grid;
  gap: ${rem(16)};

  ${mediaQueryUp.tablet} {
    grid-template-columns: repeat(2, 1fr);
  }
`

export const shipFactIconMap: Record<string, React.ComponentType<any>> = {
  length: LineRulerIcon,
  height: LineRulerIcon,
  passenger_capacity: LineUsersAltIcon,
  crew_capacity: LineUserMdIcon,
  weight: LineWeightIcon,
  performance: LineDashboardIcon,
  history: LineBooksIcon,
  registry: LineShieldCheckIcon,
  certifications: LineShieldCheckIcon,
  decks: LineLayersIcon,
  accommodation: LineBedDoubleIcon,
  construction: LineBoltIcon,
  technical: LineBoltIcon,
  capacity: LineUsersAltIcon,
  dimensions: LineRulerIcon,
  other: LineShipIcon,
}

interface Props {
  offer: App.CruiseOffer;
}

function CruiseShipFacts({
  offer,
}: Props) {
  const shipFacts = offer.ship.facts || []
  if (!shipFacts.length) return null

  return <FactsGrid>
    {shipFacts.map(fact => {
      const Icon = shipFactIconMap[fact.category]
      return <BodyTextBlock
        variant="medium"
        key={fact.name}
        startIcon={Icon ? <Icon /> : null}
      >
        {fact.name}: <b>{fact.description}</b>
      </BodyTextBlock>
    })}
  </FactsGrid>
}

export default CruiseShipFacts
